const id_dashboard = {
    search: { title: "cari perusahaan", placeholder: "ID Perusahaan" },
}

export default id_dashboard;